import * as React from "react";
import type { SVGProps } from "react";
const SvgShuffle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M2.4 18.296h2.981a3.6 3.6 0 0 0 2.93-1.508l1.023-1.432m11.522-9.711h-2.981a3.6 3.6 0 0 0-2.93 1.507L13.8 8.756m5.298-5.748L21.6 5.645 19.098 8.28m0 7.438 2.502 2.637-2.502 2.636M2.4 6.052h2.981a3.6 3.6 0 0 1 2.93 1.507l6.634 9.289a3.6 3.6 0 0 0 2.93 1.508h2.98"
    />
  </svg>
);
export default SvgShuffle;
